const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

export const WEARABLE_CONFIG = {
  MS_PER_MINUTE: MINUTE_MS,
  MS_PER_HOUR: HOUR_MS,
  MS_PER_DAY: DAY_MS,
  STALE_THRESHOLD_MS: DAY_MS,
  RESUME_SYNC_COOLDOWN_MS: 4 * HOUR_MS,
  AUTO_SYNC_INTERVAL_MS: HOUR_MS,
  AUTO_SYNC_RANDOM_DELAY_MS: 30 * 1000,
  MAX_SYNC_FAILURES: 3,
  MAX_SYNC_ATTEMPTS: 1,
  DEFAULT_SYNC_DAYS: 3,
  HISTORICAL_SYNC_DAYS: 7,
  MAX_HISTORICAL_DAYS: 90,
  FITBIT_MAX_REQUESTS_PER_HOUR: 150,
  RATE_LIMIT_BUFFER: 10,
  SYNC_HISTORY_LIMIT: 5,
  OAUTH_SESSION_TTL_MINUTES: 10,
  OAUTH_SESSION_TTL_MS: 10 * MINUTE_MS,
} as const;

export const FITBIT_RATE_LIMIT_THRESHOLD =
  WEARABLE_CONFIG.FITBIT_MAX_REQUESTS_PER_HOUR - WEARABLE_CONFIG.RATE_LIMIT_BUFFER;
